import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../forms';

@Component({
  selector: 'pty-customer-content',
  templateUrl: './customer-content.component.html',
  styleUrls: ['./customer-content.component.scss']
})
export class CustomerContentComponent implements OnChanges{
  @Input() partyId:string;
  //PartyContentList
  listForm:OfbizList;
  
  title:"Party Contents";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"PartyContentList",
        listFormLocation:"component://kwikstore/widget/PartyForms.xml",
        columnFields:getFields("PartyContentList",PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("PartyContentList",PART_FORMS),
        //fieldFormFields:any,
        listType:"list",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"PartyContentList",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"PartyContentList",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("PartyContentList",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("PartyContentList",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }
}
